export const instagramConfig = {
  name: 'Instagram',
  apiVersion: 'v17.0',
  requiredScopes: [
    'instagram_basic',
    'instagram_content_publish',
    'instagram_manage_insights',
    'pages_show_list',
    'pages_read_engagement',
    'business_management'
  ].join(','),
  authEndpoint: 'https://www.facebook.com/v17.0/dialog/oauth',
  tokenEndpoint: 'https://graph.facebook.com/v17.0/oauth/access_token',
  graphEndpoint: 'https://graph.facebook.com/v17.0'
}; 